import _reduce from 'lodash/reduce'
import { formatAmount } from '../currency'

/**
 * @param {string} serialized json
 * @returns {Array|Object} parsed json
 * */
function safeJsonParse (jsonString) {
  try {
    const parsedObject = JSON.parse(jsonString)
    return parsedObject
  } catch (e) {
    // eslint-disable-next-line no-console
    console.warn(`Passed string is not valid serialized json: ${jsonString}`)
    return []
  }
}

/**
 * @param {string|Object|Array} serialized json or object or array
 * @returns {string} CSV string
 * */
export function convertToCSV (objArray) {
  const parsed = typeof objArray === 'string' ? safeJsonParse(objArray) : objArray
  return _reduce(
    parsed,
    (acc, curr) => {
      let firstColumn = true
      const line = _reduce(
        curr,
        (lineAcc, lineCurr) => {
          if (firstColumn) {
            firstColumn = false
            return `${lineCurr}`
          }
          return `${lineAcc},${lineCurr}`
        },
        '',
      )
      return `${acc}${line}\r\n`
    },
    '',
  )
}

export function exportCSVFile (headers, items, fileTitle) {
  if (headers) {
    items.unshift(headers)
  }
  const jsonObject = JSON.stringify(items)

  const csv = convertToCSV(jsonObject)

  const exportedFilename = `${fileTitle}.csv` || 'export.csv'

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  if (navigator.msSaveBlob) { // IE 10+
    navigator.msSaveBlob(blob, exportedFilename)
  } else {
    const link = document.createElement('a')
    if (link.download !== undefined) { // feature detection
      // Browsers that support HTML5 download attribute
      const url = URL.createObjectURL(blob)
      link.setAttribute('href', url)
      link.setAttribute('download', exportedFilename)
      link.style.visibility = 'hidden'
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    }
  }
}

/**
 * Removes commas to make string CSV safe
 * @param {String} str String to rm commas
 * @returns {String} String minus commas
 */
export function stripComma (str) {
  return str.replace(/,/g, '')
}

/**
 * Formats currency numbers for CSV
 * @param {Number} str Number to format
 * @returns {Number} Number formatted
 */
export function getCSVNumberValue (num) {
  return stripComma(formatAmount(num))
}
